import {useAccount} from "wagmi";
import {useQuery} from "@tanstack/react-query";
import {type AddressBook, getAddressBook} from "../repository/AddressBookRepository.ts";

// @ts-ignore
export enum StaffType {
    CONTROLLER = "Controller",
    OWNER = "Owner",
    FEES_COLLECTOR = "Fees Collector",
    UNDEFINED = "Undefined"
}

export function identifyAddressRole(address: `0x${string}` | undefined, addressBook: AddressBook | undefined): StaffType {
    if (!addressBook || !address) {
        return StaffType.UNDEFINED;
    }
    if (addressBook.roles.owner === address) return StaffType.OWNER;
    if (addressBook.roles.controller === address) return StaffType.CONTROLLER;
    if (addressBook.roles.feeCollector === address) return StaffType.FEES_COLLECTOR;
    return StaffType.UNDEFINED;
}

export function useStaffGuard() {
    const { isConnected, address } = useAccount();
    const { data: addressBook, isLoading, isError } = useQuery({
        queryKey: ["address-book"],
        queryFn: getAddressBook,
    });
    const isStaff = isConnected && !isLoading && !isError &&
        (addressBook?.roles.controller === address ||
            addressBook?.roles.owner === address ||
        addressBook?.roles.feeCollector === address);
    const role =  identifyAddressRole(address, addressBook);
    return { isStaff, isLoading, role };
}
